import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { FormActions, FormStatusSwitch } from 'views/Components';

class GrupoMercadoriaForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        isNewRecord: false,
        isView: false,
        grupomercadoria: {
            codgrupomercadoria: '',
            descgrupomercadoria: '',
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descgrupomercadoria: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição do grupo obrigatória'
                },
                length: { maximum: 50 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    grupomercadoria: this.getGrupoMercadoriaDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadGrupoMercadoria(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar grupo de mercadoria:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar grupo de mercadoria!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o grupo de mercadoria padrão */
    getGrupoMercadoriaDefault = () => ({
        codgrupomercadoria: '',
        descgrupomercadoria: '',
        inativo: ANAO
    });

    /* Carrega o grupo de mercadoria */
    loadGrupoMercadoria = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/grupomercadoria/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Grupo de mercadoria não encontrado!');

            history.push('/estoque/grupomercadoria');

            return;
        }

        this.safeSetState({
            grupomercadoria: {
                codgrupomercadoria: registro.codgrupomercadoria || '',
                descgrupomercadoria: registro.descgrupomercadoria || '',
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox'
            ? (checked ? ANAO : ASIM)
            : typeof value === 'string' ? value.toUpperCase() : value;

        this.setState(prevState => ({
            grupomercadoria: {
                ...prevState.grupomercadoria,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de grupo de mercadoria */
    getPayloadGrupoMercadoria = () => {
        const { grupomercadoria } = this.state;

        return {
            descgrupomercadoria: grupomercadoria.descgrupomercadoria || '',
            inativo: grupomercadoria.inativo || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { grupomercadoria, isNewRecord } = this.state;
        const { history, loadGrupoMercadoria } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadGrupoMercadoria();

            if (isNewRecord) {
                await api.post('/grupomercadoria', payload);
            } else {
                await api.put(`/grupomercadoria/${grupomercadoria.codgrupomercadoria}`, payload);
            }

            if (loadGrupoMercadoria) loadGrupoMercadoria();

            history.push('/estoque/grupomercadoria');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/estoque/grupomercadoria');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { grupomercadoria, schema } = this.state;

        return validateSchemaFields(
            grupomercadoria,
            schema,
            ['descgrupomercadoria']
        );
    };

    render() {
        const {
            errors,
            grupomercadoria,
            isView,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Grupo de mercadoria {grupomercadoria.codgrupomercadoria}
                        </Typography>

                        <FormStatusSwitch
                            checked={grupomercadoria.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descgrupomercadoria"
                            value={grupomercadoria.descgrupomercadoria || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descgrupomercadoria || ''}
                            error={!!errors.descgrupomercadoria}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            fullWidth
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

GrupoMercadoriaForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadGrupoMercadoria: PropTypes.func
};

export default GrupoMercadoriaForm;